import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Ensure you import styles
import '@mdi/font/css/materialdesignicons.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi'; // Optional icons
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

const vuetify = createVuetify({
    components,
    directives,
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#1976D2',
                    secondary: '#424242',
                },
            },
        },
    },
    icons: {
        defaultSet: 'mdi', // Make sure 'mdi' is set as the default icon set
        aliases,
        sets: {
          mdi,
        },
    },
});

export default vuetify;